import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Form,
  message,
  Select,
  Input,
  DatePicker,
  Checkbox,
  Radio,
  TimePicker,
} from "antd";
import { RULES_ANTD } from "../../constants/index";

const { Option } = Select;

FromUpdateRegisterNormal.propTypes = {};

function FromUpdateRegisterNormal(props) {
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);
  const [location_medicines, setLocationMedicines] = useState([]);
  const [pathogens, setPathogens] = useState([]);
  const [registerAccount, setRegisterAccount] = useState(false);
  const [typeInfoUser, setTypeInfoUser] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    getList();
  }, []);

  //handle checkbox

  // handle location
  const getProvinces = async () => {
    const result = await fetch(
      "https://potec.hap-technology.com/api-order/order/provinces"
    ).then((data) => {
      return new Promise((resolve, reject) => {
        resolve(data.json());
      });
    });
    setProvinces(result.data);
  };
  const getDistricts = async (id) => {
    if (id) {
      const result = await fetch(
        `https://potec.hap-technology.com/api-order/order/districts?province_id=${id}`
      ).then((data) => {
        return new Promise((resolve, reject) => {
          resolve(data.json());
        });
      });

      setDistricts(result.data);
    }
  };
  const getWards = async (id) => {
    if (id) {
      const result = await fetch(
        `https://potec.hap-technology.com/api-order/order/wards?district_id=${id}`
      ).then((data) => {
        return new Promise((resolve, reject) => {
          resolve(data.json());
        });
      });

      setWards(result.data);
    }
  };

  const handleChangeProvinces = (value) => {
    if (value) {
      getDistricts(value);
    }
    form.resetFields(["district_id", "ward_id"]);
  };

  const handleChangeDistricts = (value) => {
    if (value) {
      getWards(value);
    }
    form.resetFields(["ward_id"]);
  };

  const getLocationMedical = async () => {
    const result = await fetch(
      "https://potec.hap-technology.com/api-order/order/location-medicines"
    ).then((data) => {
      return new Promise((resolve, reject) => {
        resolve(data.json());
      });
    });
    setLocationMedicines(result.data);
  };

  const getPathogens = async () => {
    const result = await fetch(
      "https://potec.hap-technology.com/api-order/order/pathogens"
    ).then((data) => {
      return new Promise((resolve, reject) => {
        resolve(data.json());
      });
    });
    setPathogens(result.data);
  };

  const getList = async () => {
    Promise.all([getProvinces(), getPathogens(), getLocationMedical()]);
  };
  //

  // handle on summit
  const onSubmit = async (value) => {
    console.log(value);

    const newValue = {
      full_name: value.full_name,
      gender: value.gender,
      birth_day: moment(value.birth_day).format("DD/MM/YYYY"),
      code_note: value.code_note,
      phone_number: value.phone_number,
      email: value.email,
      address: value.address,
      province_id: value.province_id,
      district_id: value.district_id,

      ward_id: value.ward_id,
      contact_person_1_name: value.contact_person_1_name,
      contact_person_1_phone_number: value.contact_person_1_phone_number,
      contact_person_1_relationship: value.contact_person_1_relationship,
      contact_person_2_name: value.contact_person_2_name,

      contact_person_2_phone_number: value.contact_person_2_phone_number,
      contact_person_2_relationship: value.contact_person_2_relationship,
      type_injection: value.type_injection,
      pathogen_id: value.pathogen_id,
      location_medical: value.location_medical,
      booking_date: moment(value.booking_date).format("DD/MM/YYYY"),
    };

    // const res = await fetch(
    //   "https://potec.hap-technology.com/api-order/order/order",
    //   {
    //     method: "POST",
    //     body: JSON.stringify(newValue),
    //     headers: { "Content-type": "application/json; charset=UTF-8" },
    //   }
    // )
    //   .then((data) => {
    //     return new Promise((resolve, reject) => {
    //       resolve(data.json());
    //     });
    //   })
    //   .catch((err) => console.log(err));

    // if (res.code === "200") {
    //   message.success(res.message);
    // }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Bạn chưa nhập đầy đủ thông tin");
    return;
  };
  //
  return (
    <>
      <Form
        // initialValues={state}
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <h1 className="content__title--one">
          Đằng kí tiêm chủng vắc xin thông thường
        </h1>

        <h1 className="content__title--two">Thông tin khách hàng</h1>
        <div className="content__content--one row">
          {/* <!-- name --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="fullName"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.name}
              label="Họ và tên người đăng ký"
            >
              <Input
                disabled={registerAccount}
                placeholder="Họ và tên người tiêm (*)"
              />
            </Form.Item>
          </div>
          {/* <!-- Gender --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="gender"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.gender}
              label="Giới tính"
            >
              <Select
                disabled={registerAccount}
                placeholder="Giới Tính"
                allowClear
              >
                <Option value="MALE">Nam</Option>
                <Option value="FEMALE">Nữ</Option>
              </Select>
            </Form.Item>
          </div>
          {/* <!-- date --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="birth_day"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.birth_day}
              label="Ngày sinh"
            >
              <DatePicker
                disabled={registerAccount}
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="Ngày sinh định dạng 25/03/2021 (*)"
              />
            </Form.Item>
          </div>
          {/* <!-- mã số tiêm chủng  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="code_note"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.code_note}
              label="Mã sổ tiêm chủng"
            >
              <Input
                disabled={registerAccount}
                placeholder="Mã số tiêm chủng nếu có"
              />
            </Form.Item>
          </div>
          <div className="content__checkbox col-12">
            <Form.Item name="checkboxRegisterUser" valuePropName="checked">
              <Checkbox
                checked={registerAccount}
                onChange={() => setRegisterAccount(!registerAccount)}
              >
                Đã đăng kí tài khoản
              </Checkbox>
            </Form.Item>
          </div>

          {/* <!-- phone --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Điện thoại đăng ký "
              name="phone_number"
              hasFeedback
              rules={RULES_ANTD.phone}
            >
              <Input type="number" placeholder="Điện thoại đăng ký (*)" />
            </Form.Item>
          </div>
          {/* <!-- email --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Email đăng ký"
              name="email"
              hasFeedback
              rules={RULES_ANTD.email}
            >
              <Input placeholder="Email đăng kí (*)" />
            </Form.Item>
          </div>

          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Mật khẩu"
              name="password"
              hasFeedback
              rules={RULES_ANTD.password}
            >
              <Input placeholder="Mật khẩu (*)" />
            </Form.Item>
          </div>

          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Nhập lại mật khẩu"
              name="confirmPassword"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input placeholder="Nhập lại mật khẩu" />
            </Form.Item>
          </div>
          {/* <!-- địa chỉ hộ khẩu --> */}
          <div className="col-sm-12">
            <Form.Item
              name="address"
              hasFeedback
              label="Địa chỉ"
              rules={RULES_ANTD.address}
            >
              <Input placeholder="Chỗ ở hiện tại" />
            </Form.Item>
          </div>
          {/* <!-- tỉnh thành  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Quốc gia"
              name="country_id"
              hasFeedback
              rules={RULES_ANTD.provinces}
            >
              <Select
                // notFoundContent={null}
                placeholder="Quốc gia"
                onChange={handleChangeProvinces}
                showSearch
                allowClear
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                <Select.Option key={0} value="country1" className="country1">
                  country 1
                </Select.Option>
                <Select.Option key={1} value="country2" className="country2">
                  country 2
                </Select.Option>
                <Select.Option key={0} value="country3" className="country3">
                  country 3
                </Select.Option>
              </Select>
            </Form.Item>
          </div>

          {/* <!-- tỉnh thành  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Tỉnh thành"
              name="province_id"
              hasFeedback
              rules={RULES_ANTD.provinces}
            >
              <Select
                // notFoundContent={null}
                placeholder="Tỉnh thành"
                onChange={handleChangeProvinces}
                showSearch
                allowClear
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {provinces &&
                  provinces.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item._id}
                      className={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>

          {/* <!-- quân huyện --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Quận huyện"
              name="district_id"
              hasFeedback
              rules={RULES_ANTD.districts}
            // notFoundContent={null}
            >
              <Select
                placeholder="Quận huyện"
                allowClear
                onChange={handleChangeDistricts}
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {districts &&
                  districts.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item._id}
                      className={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
          {/* <!-- phường xã --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="ward_id"
              label="Phường xã"
              hasFeedback
              rules={RULES_ANTD.wards}
            >
              <Select
                placeholder="Phường xã"
                label="Phường xã"
                allowClear
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {wards &&
                  wards.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item._id}
                      className={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
          <h1 className="content__title--two col-12">Thông tin người tiêm</h1>

          <div className="content__checkbox col-12">
            <Form.Item className="col-12" name="radio-button">
              <Radio.Group
                defaultValue={typeInfoUser}
                onChange={() => setTypeInfoUser(!typeInfoUser)}
              >
                <Radio className="w-50" value={false}>
                  {" "}
                  Đăng kí tiêm cá nhân
                </Radio>
                <Radio className="w-50 pl-3" value={true}>
                  {" "}
                  Đăng kí tiêm gia đình
                </Radio>
              </Radio.Group>
            </Form.Item>
          </div>

          <div className=" col-12">
            <div className="w-50 " style={{ paddingRight: "15px" }}>
              <Form.Item
                className=""
                name="people_signIn"
                hasFeedback
                rules={
                  typeInfoUser ? RULES_ANTD.contact_person_1_phone_number : null
                }
              >
                <Input
                  disabled={!typeInfoUser}
                  placeholder="Số người đăng ký"
                  style={{ fontSize: 15 }}
                  type="number"
                />
              </Form.Item>
            </div>
          </div>
          {typeInfoUser && (
            <>
              {/* <!-- người liên hệ 1 --> */}
              <div className="col-md-6 col-sm-12">
                <Form.Item
                  label="Người tiêm 1"
                  name="contact_person_1_name"
                  hasFeedback
                  rules={RULES_ANTD.contact_person_1_phone_number}
                >
                  <Input
                    placeholder="Người liên hệ 1"
                    style={{ fontSize: 15 }}
                  />
                </Form.Item>
              </div>

              {/* <!-- Ngày sinh --> */}
              <div className="col-md-2 col-sm-4  pr-0">
                <Form.Item
                  name="contact_person_2_birthday"
                  hasFeedback
                  rules={RULES_ANTD.birth_day}
                  label="Ngày sinh"
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    style={{ width: "100%" }}
                    placeholder="Ngày sinh định dạng 25/03/2021 (*)"
                  />
                </Form.Item>
              </div>

              {/* <!-- Giới tính --> */}

              <div className="col-md-2 col-sm-4 pr-0 pl-2">
                <Form.Item
                  label="Giới tính "
                  name="contact_person_1_gender"
                  hasFeedback
                  rules={RULES_ANTD.contact_relationship}
                >
                  <Select placeholder="Quan hệ" allowClear size="middle">
                    <Option value="Cha">Cha</Option>
                    <Option value="Mẹ">Mẹ</Option>
                    <Option value="khác">Khác</Option>
                  </Select>
                </Form.Item>
              </div>
              {/* <!-- quan hệ --> */}
              <div className="col-md-2 col-sm-4 pl-2 ">
                <Form.Item
                  label="Quan hệ "
                  name="contact_person_1_relationship"
                  hasFeedback
                  rules={RULES_ANTD.contact_relationship}
                >
                  <Select placeholder="Quan hệ" allowClear size="middle">
                    <Option value="Cha">Cha</Option>
                    <Option value="Mẹ">Mẹ</Option>
                    <Option value="khác">Khác</Option>
                  </Select>
                </Form.Item>
              </div>

              {/* <!-- người liên hệ 2 --> */}
              <div className="col-md-6 col-sm-12">
                <Form.Item
                  label="Người tiêm 2"
                  name="contact_person_2_name"
                  hasFeedback
                  rules={RULES_ANTD.contact_person_1_phone_number}
                >
                  <Input
                    placeholder="Người liên hệ 1"
                    style={{ fontSize: 15 }}
                  />
                </Form.Item>
              </div>

              {/* <!-- Ngày sinh --> */}
              <div className="col-md-2 col-sm-4  pr-0">
                <Form.Item
                  name="contact_person_2_birthday"
                  hasFeedback
                  rules={RULES_ANTD.birth_day}
                  label="Ngày sinh"
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    style={{ width: "100%" }}
                    placeholder="Ngày sinh định dạng 25/03/2021 (*)"
                  />
                </Form.Item>
              </div>

              {/* <!-- Giới tính --> */}

              <div className="col-md-2 col-sm-4 pr-0 pl-2">
                <Form.Item
                  label="Giới tính "
                  name="contact_person_1_gender"
                  hasFeedback
                  rules={RULES_ANTD.contact_relationship}
                >
                  <Select placeholder="Quan hệ" allowClear size="middle">
                    <Option value="Cha">Cha</Option>
                    <Option value="Mẹ">Mẹ</Option>
                    <Option value="khác">Khác</Option>
                  </Select>
                </Form.Item>
              </div>
              {/* <!-- quan hệ --> */}
              <div className="col-md-2 col-sm-4 pl-2 ">
                <Form.Item
                  label="Quan hệ "
                  name="contact_person_1_relationship"
                  hasFeedback
                  rules={RULES_ANTD.contact_relationship}
                >
                  <Select placeholder="Quan hệ" allowClear size="middle">
                    <Option value="Cha">Cha</Option>
                    <Option value="Mẹ">Mẹ</Option>
                    <Option value="khác">Khác</Option>
                  </Select>
                </Form.Item>
              </div>
            </>
          )}
        </div>
        <h1 className="content__title--two">Thông tin tiêm chủng</h1>

        <div className="content__content--one row">
          {/* <!-- Danh mục kháng nguyên --> */}
          <div className="col-md-12 col-sm-12">
            <Form.Item
              name="pathogen_id"
              hasFeedback
              rules={RULES_ANTD.pathogen}
              label="Tên vắc xin đăng kí"
            >
              <Select
                placeholder="Kháng nguyên"
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                allowClear
              >
                {pathogens &&
                  pathogens.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item._id}
                      className={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>

          {/* <!-- Ngày tiêm --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Ngày tiêm đăng kí"
              name="booking_date"
              hasFeedback
              rules={RULES_ANTD.date_injection}
            >
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="Ngày tiêm"
              />
            </Form.Item>
          </div>

          {/* <!-- cơ sở tiêm chủng --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Lựa chọn sơ sở tiêm đăng ký"
              name="location_medical"
              hasFeedback
              rules={RULES_ANTD.location_medical}
            >
              <Select
                placeholder="Cơ sở tiêm chủng"
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                allowClear
              >
                {location_medicines &&
                  location_medicines.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item._id}
                      className={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>

          {/* <!-- Giờ tiêm --> */}
          <div className="col-md-3 col-sm-12 pr-0">
            <Form.Item
              label="Giờ tiêm xác nhận"
              name="timeConfirm"
              hasFeedback
              rules={RULES_ANTD.date_injection}
            >
              <TimePicker
                style={{ width: "100%" }}
                placeholder="Giờ tiêm xác nhận"
              />
            </Form.Item>
          </div>
          {/* <!-- Giờ tiêm --> */}
          <div className="col-md-3 col-sm-12">
            <Form.Item
              label="Ngày tiêm xác nhận"
              name="dateConfirm"
              hasFeedback
              rules={RULES_ANTD.date_injection}
            >
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="Ngày tiêm xác nhận"
              />
            </Form.Item>
          </div>

          {/* <!-- cơ sở tiêm chủng --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item label="Trạng thái đăng kí" name="statusConfirm">
              <Select
                placeholder="Trạng thái đăng kí"
                showSearch
                allowClear
                defaultValue={1}
              >
                <Select.Option value={1}>Chờ xác nhận</Select.Option>
                <Select.Option value={2}>Thành công </Select.Option>
                <Select.Option value={3}>Đã tiêm </Select.Option>
                <Select.Option value={4}>Hủy đăng kí </Select.Option>
              </Select>
            </Form.Item>
          </div>

          <div className="col-md-6 col-sm-12">
            <button className="btn btnSubmit  mb-4">Cập nhật</button>
          </div>
          <div className="col-md-6 col-sm-12 desc-info mb-3"></div>
        </div>
      </Form>
    </>
  );
}

export default FromUpdateRegisterNormal;
